import { useProfile } from 'context/Profile'

const Theme = ( {
  children
} ) => {
  const profile = useProfile()

  Object
    .keys( profile.themeParams )
    .forEach( k => {
      document
        .documentElement
        .style
        .setProperty(
          `--${ k }`,
          profile.themeParams[ k ]
        )
    } )

  return children
}

export default Theme
